import _, { concat } from 'lodash';
import constantsCommon from '$$helpers/constants';
import rights from '../../../../../components/rights';

export const isMassChangeColVisible = instance => {
  if (!instance.ganttDataApi.isBase() || instance.config.multiview) {
    return false;
  }

  return rights.project.hasRightSomeOne(instance.config.gantt_id, [
    'static_fields',
    'delete_task',
    'static_fields_4_only',
    'custom_field_edit',
  ]);
};

export const hasCostsColRights = instance => {
  let hasCostRight = false;

  if (instance.config.multiview) {
    hasCostRight = instance.ganttDataApi.getActiveProjectData().ganttIDs.some(ganttId => rights.project.hasCostRight(ganttId));
  } else {
    hasCostRight = rights.project.hasCostRight(instance.config.gantt_id);
  }

  return hasCostRight;
};

export const getNormalizedColumnName = column => {
  if (column.name === 'total_price') {
    return 'costs';
  }
  if (column.name === 'overload') {
    return 'workload';
  }

  return column.name;
};

export const verifyColumnsOrder = columnsOrder =>
  // just "zapasochka" to be sure that we do not have bullshit in database in case of columns DND bug
  concat(
    constantsCommon.COLUMN_ORDER.ALWAYS_FIXED_START,
    _.difference(columnsOrder, constantsCommon.COLUMN_ORDER.ALWAYS_FIXED_START, constantsCommon.COLUMN_ORDER.ALWAYS_FIXED_END),
    constantsCommon.COLUMN_ORDER.ALWAYS_FIXED_END,
  );

export const getCorrectGridWidthAfterResize = (newWidth, windowParams) => {
  const ganttExpandButton = document.querySelector('.gantt_expand_button');

  if (ganttExpandButton) {
    const maxGridWidth = parseFloat(windowParams.width) - ganttExpandButton.clientWidth;

    if (newWidth > maxGridWidth) {
      return { width: maxGridWidth, needRender: true };
    }
  }

  return { width: newWidth, needRender: false };
};
